import { CSSProperties } from 'react';

import { AppColors } from '../../theme';

type StatusCardStyles = {
  statusCard: CSSProperties;
  statusCard__count: CSSProperties;
  statusCard__label: CSSProperties;
  statusCard__disabled: CSSProperties;
  statusCard__variant: {
    created: CSSProperties;
    'in-progress': CSSProperties;
    'partially-delivered': CSSProperties;
    delivereds: CSSProperties;
    overdue: CSSProperties;
  };
  statusCard__variantActive: {
    created: CSSProperties;
    'in-progress': CSSProperties;
    'partially-delivered': CSSProperties;
    delivereds: CSSProperties;
    overdue: CSSProperties;
  };
};

const styles: StatusCardStyles = {
  statusCard: {
    borderRadius: '8px',
    padding: '16px',
    border: '1px solid transparent',
    display: 'flex',
    alignItems: 'center',
    transition: 'all 0.2s ease-in-out',
    width: 'clamp(160px, 45vw, 202px)',
    height: '80px',
    boxSizing: 'border-box',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
  },
  statusCard__count: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: AppColors.VA.NEUTRALS._90_,
    lineHeight: '1'
  },
  statusCard__label: {
    fontSize: '14px',
    fontWeight: 'normal',
    color: AppColors.VA.NEUTRALS._90_,
    lineHeight: '1.4',
    flex: 1
  },
  statusCard__disabled: {
    opacity: 0.5,
    backgroundColor: AppColors.VA.NEUTRALS._20_,
    border: '1px solid transparent'
  },
  statusCard__variant: {
    created: {
      backgroundColor: AppColors.VA.NEUTRALS._30_
    },
    'in-progress': {
      backgroundColor: AppColors.VA.INFO._10_,
      border: `1px solid ${AppColors.VA.INFO._30_}`
    },
    'partially-delivered': {
      backgroundColor: AppColors.VA.WARNING._10_
    },
    delivereds: {
      backgroundColor: AppColors.VA.SUCCESS._10_
    },
    overdue: {
      backgroundColor: AppColors.VA.ERROR._20_
    }
  },
  statusCard__variantActive: {
    created: {
      backgroundColor: AppColors.VA.NEUTRALS._30_,
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
    },
    'in-progress': {
      backgroundColor: AppColors.VA.INFO._20_,
      border: `1px solid ${AppColors.VA.INFO._50_}`,
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 8px rgba(18, 193, 248, 0.25)'
    },
    'partially-delivered': {
      backgroundColor: AppColors.VA.WARNING._20_,
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 8px rgba(255, 222, 32, 0.25)'
    },
    delivereds: {
      backgroundColor: AppColors.VA.SUCCESS._20_,
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 8px rgba(17, 210, 158, 0.25)'
    },
    overdue: {
      backgroundColor: AppColors.VA.ERROR._30_,
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 8px rgba(255, 42, 64, 0.25)'
    }
  }
};

export default styles;
